import { useCallback, useEffect, useRef, useState } from 'react';
import { apiUrl } from '../../config/api';

/** Landing page hero + mid-page carousels. */
const useCarousel = () => {
  const [firstCarousel, setFirstCarousel] = useState([]);
  const [secondCarousel, setSecondCarousel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const fetchCarousel = useCallback(async () => {
    try {
      const response = await fetch(apiUrl('/api/all-carousels'));
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      if (!isMounted.current) return;
      setFirstCarousel(data.first_carousal || []);
      setSecondCarousel(data.second_carousal || []);
      setError(null);
    } catch (err) {
      if (isMounted.current) setError(err.message);
    } finally {
      if (isMounted.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCarousel();
  }, [fetchCarousel]);

  return { firstCarousel, secondCarousel, loading, error, fetchCarousel };
};

export default useCarousel;
